import { Controller } from '@hotwired/stimulus';

export default class LowOperationWarningController extends Controller {
  static targets = ['input', 'warning'];

  static values = {
    threshold: { type: Number, default: 3 },
    debounce: { type: Number, default: 400 },
  };

  disconnect() {
    if (this.debounceHandle) clearTimeout(this.debounceHandle);
  }

  check() {
    if (this.debounceHandle) clearTimeout(this.debounceHandle);
    this.debounceHandle = setTimeout(() => this.update(), this.debounceValue);
  }

  update() {
    const value = parseInt(this.inputTarget.value, 10);
    const shouldShow = Number.isFinite(value) && value >= 1 && value < this.thresholdValue;
    this.warningTarget.classList.toggle('d-none', !shouldShow);
  }
}
